import { call, put, select } from 'redux-saga/effects';
import { getFeatures as getFeaturesAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getFeatures(params) {
  const {
    cqId,
    chosenActionsArray,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = {
      cqId,
    };
    if (Array.isArray(chosenActionsArray)) {
      args.chosenActionsArray = chosenActionsArray;
    }
    const response = yield call(getFeaturesAda, args, context);
    if (successUpdate) {
      yield put(successUpdate(response));
    }

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_FEATURES, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
